import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ThreadTopicBarVisibilityAction } from '../../domains/threadTopicBarVisibility/actions.types';
import type { AddThreadTopicPendingAction } from '../../domains/topics/actions.types';

import type { ThreadTopicBarVisibility } from './types';

type ThreadTopicBarActions = ThreadTopicBarVisibilityAction | AddThreadTopicPendingAction;

const initialState: ThreadTopicBarVisibility = {};

const reducer: Reducer<ThreadTopicBarVisibility, ThreadTopicBarActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD_TOPIC_BAR.OPENED':
      return addToRecord(state, action.payload.threadId, true);
    case 'THREAD_TOPIC_BAR.CLOSED':
      return addToRecord(state, action.payload.threadId, false);
    case 'THREAD_TOPIC.ADD_PENDING':
      return addToRecord(state, action.payload.threadId, true);
    default:
      return state;
  }
};

export default reducer;
